import React, { Component } from 'react';
import { connect } from 'react-redux';
import { orderBy, filter, some, map } from 'lodash';

import AdminBar from '../../components/AdminBar';
import Header from '../../components/DualMatchProfile/HeaderNew';
import ResultsTab from '../../components/DualMatchProfile/ResultsTab/ResultsTabTmsDualMatch';
import head from '../../components/Meta';
import PopOverMenu from '../../components/PopOverMenu';
import { AddOrUpdateDualMatchEventDrawPopup } from '../../components/PopUps';
import DeleteEventFailedPopup from '../../components/Events/Popups/DeleteEventFailedPopup';
import Popup from './popup/popup';

import * as eventActions from '../../actions/event-actions';
import { setRound } from '../../actions/post-score-actions';
import * as loginPopUpActions from '../../actions/login-popup-actions';
import { config } from '../../../config';
import { getAddDrawGenderId } from '../../utils/events';

import styles from './dualMatch.scss';
import EditDualMatchEventPopup from '../../components/PopUps/EditDualMatchEventPopup';

const _ = { orderBy, filter, some, map };

class AdultTeamTennisMatchProfilePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAdmin: true,
        };
        this.updateState = this.updateState.bind(this);
        this.redirectTo = this.redirectTo.bind(this);
        this.handlePostScore = this.handlePostScore.bind(this);
        this.handleTeamScoreChange = this.handleTeamScoreChange.bind(this);
        this.handleTeamWinnerChange = this.handleTeamWinnerChange.bind(this);
        this.handlePlayerSelect = this.handlePlayerSelect.bind(this);
        this.handleTeamSelect = this.handleTeamSelect.bind(this);
        this.handleAddMatch = this.handleAddMatch.bind(this);
        this.handleDeleteMatch = this.handleDeleteMatch.bind(this);
        this.handlePublish = this.handlePublish.bind(this);
        this.handleUnpublish = this.handleUnpublish.bind(this);
        this.handleAdminOptionSelect = this.handleAdminOptionSelect.bind(this);
        this.handleUpdateDualMatchEvent = this.handleUpdateDualMatchEvent.bind(this);
        this.showPopUp = this.showPopUp.bind(this);
        this.handlePopUpConfirm = this.handlePopUpConfirm.bind(this);
        this.handleAddDrawAsync = this.handleAddDrawAsync.bind(this);
        this.showAddDrawPopup = this.showAddDrawPopup.bind(this);
        this.hideAddDrawPopup = this.hideAddDrawPopup.bind(this);
        this.handleAdminDrawOptionSelect = this.handleAdminDrawOptionSelect.bind(this);
        this.handleUpdateDrawAsync = this.handleUpdateDrawAsync.bind(this);
        this.showUpdateDrawPopup = this.showUpdateDrawPopup.bind(this);
        this.hideUpdateDrawPopup = this.hideUpdateDrawPopup.bind(this);
        this.handlePopupCancel = this.handlePopupCancel.bind(this);
    }

    componentDidMount() {
        this.updateState(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        console.log('componentWillReceiveProps', nextProps);
        this.updateState(nextProps);
    }

    updateState(props) {
        const event = props.events.currentEvent.data;
        const isAdmin = event &&
            event.currentMember &&
            event.currentMember.eventDirectorRole &&
            (event.currentMember.eventDirectorRole.id === 1 || event.currentMember.eventDirectorRole.id === 2);

        if (event && !event.published && !isAdmin) {
            this.props.history.push('/');
        }

        if (event && event.eventTeams) {
            const { eventTeams } = event;
            const playersDict = {};
            const teamsDict = {};
            let team1; let team2;

            if (!eventTeams[0].isHome) {
                team1 = eventTeams[0].roster;
                team2 = eventTeams[1].roster;
            } else {
                team1 = eventTeams[1].roster;
                team2 = eventTeams[0].roster;
            }

            const playersTeam1 = team1;
            const playersTeam2 = team2;

            const orderedPlayersTeam1 = _.orderBy(playersTeam1, event.utrType.value === 'sanctioned' ? ['ratingStatusSinglesVal', 'singlesUtr'] : 'myUtr', ['desc', 'desc']);
            const orderedPlayersTeam2 = _.orderBy(playersTeam2, event.utrType.value === 'sanctioned' ? ['ratingStatusSinglesVal', 'singlesUtr'] : 'myUtr', ['desc', 'desc']);

            const teams = event.teams ? event.teams : [];
            const orderedTeams = _.orderBy(teams, event.utrType.value === 'sanctioned' ? 'averageDoublesUtr' : 'averageDoublesMyUtr', 'desc');

            const orderedPlayers = [...orderedPlayersTeam1, ...orderedPlayersTeam2];
            orderedPlayers.forEach((player) => {
                playersDict[player.id] = player;
            });

            orderedTeams.forEach((team) => {
                teamsDict[team.id] = team;
            });

            const team1Players = orderedPlayersTeam1;
            const team2Players = orderedPlayersTeam2;

            this.setState({
                playersDict,
                teamsDict,
                team1Players,
                team2Players,
                isAdmin,
            });
        }
    }

    redirectTo(route) {
        this.props.history.push(route);
    }

    async handleTeamScoreChange(score, clubId) {
        console.log('handleTeamScoreChange', score, clubId);
        const event = this.props.events.currentEvent.data;
        const scoreArr = event.teamEventScoreDetail.scores.map((team) => {
            if (team.clubId === clubId) {
                return {
                    clubId,
                    score: score ? parseInt(score) : 0,
                    isWinner: team.isWinner,
                };
            }
            return team;
        });
        const scoreObj = {
            ...event.teamEventScoreDetail,
            scores: scoreArr,
        };
        console.log('newScoreObj', scoreObj);
        await this.props.updateEventTeamScores(event.id, scoreObj);
    }

    async handleTeamWinnerChange(isWinner, clubId) {
        const event = this.props.events.currentEvent.data;
        const scoreArr = event.teamEventScoreDetail.scores.map((team) => {
            if (team.clubId === clubId) {
                return {
                    clubId,
                    score: team.score,
                    isWinner,
                };
            }
            if (team.clubId !== clubId && isWinner) {
                return {
                    clubId: team.clubId,
                    score: team.score,
                    isWinner: false,
                };
            }
            return team;
        });
        const scoreObj = {
            ...event.teamEventScoreDetail,
            scores: scoreArr,
        };
        await this.props.updateEventTeamScores(event.id, scoreObj);
    }

    handlePostScore(selectedDrawId, matchIndex) {
        const event = this.props.events.currentEvent.data;
        const data = {
            eventId: event.id,
            selectedDrawId,
            roundIndex: 0,
            matchIndex,
            activeRound: 0,
        };
        console.log('handlePostScore', selectedDrawId, matchIndex);
        this.props.setRound(data);
        this.props.history.push('/post-score');
    }

    handlePlayerSelect(drawId, matchId, position, player) {
        const eventId = this.props.events.currentEvent.data.id;
        console.log('updateMatchPositions', eventId, drawId, matchId, position, player);
        this.props.updateMatchPositions(eventId, drawId, matchId, position, player);
    }

    handleTeamSelect(drawId, matchId, position, team) {
        const eventId = this.props.events.currentEvent.data.id;
        console.log('updateMatchPositions', eventId, drawId, matchId, position, team);
        this.props.updateMatchPositions(eventId, drawId, matchId, position, team);
    }

    handleAddMatch(drawId, roundId) {
        console.log('handleAddMatch', drawId, roundId);
        this.props.addMatchToRound(drawId, roundId);
    }

    handleDeleteMatch(drawId, matchId) {
        console.log('handleDeleteMatch', drawId, matchId);
        this.props.deleteMatch(drawId, matchId);
    }

    handlePublish() {
        const eventId = this.props.events.currentEvent.data.id;
        this.props.publishEvent(eventId);
    }

    handleUnpublish() {
        const eventId = this.props.events.currentEvent.data.id;
        this.props.unPublishEvent(eventId);
    }

    async handleAddDrawAsync(values) {
        const eventId = this.props.events.currentEvent.data.id;
        return this.props.addDraw(eventId, { ...values, genderId: getAddDrawGenderId(this.props.events.currentEvent.data) });
    }

    showAddDrawPopup() {
        this.setState({
            showAddDrawPopup: true,
        });
    }

    hideAddDrawPopup() {
        this.setState({
            showAddDrawPopup: false,
        });
    }

    async handleUpdateDrawAsync(values) {
        const eventId = this.props.events.currentEvent.data.id;
        const draws = await this.props.updateDrawAsync(eventId, values.drawId, values);
        return draws;
    }

    showUpdateDrawPopup(drawId, drawName) {
        this.setState({
            drawIdToUpdate: drawId,
            drawNameToUpdate: drawName,
            showUpdateDrawPopup: true,
        });
    }

    hideUpdateDrawPopup() {
        this.setState({
            drawIdToUpdate: null,
            drawNameToUpdate: null,
            showUpdateDrawPopup: false,
        });
    }

    handleAdminDrawOptionSelect(option, drawId, drawName) {
        switch (option.value) {
            case 'edit':
                this.showUpdateDrawPopup(drawId, drawName);
                break;
            case 'delete': {
                this.setState({
                    drawToDelete: drawId,
                }, () => {
                    this.showPopUp({
                        type: 'delete_draw',
                        message: 'Delete draw? Any scores will also be deleted.',
                    });
                });
                break;
            }
            default:
                break;
        }
    }

    handleAdminOptionSelect(option) {
        switch (option.value) {
            case 'delete': {
                const event = this.props.events.currentEvent.data;
                const hasResults = _.some(event.draws, (d) => _.some(d.rounds,
                    r => _.some(r.matches, m => m.result)));

                if (hasResults) {
                    this.props.showDeleteFailedPopup();
                    return;
                }
                this.showPopUp({
                    type: 'delete_event',
                    message: 'Deleting this event will mean that no players will be able to search or view this event. You can not retrieve the event in the future.',
                });

                break;
            }
            case 'include_in_standings':
                this.showPopUp({
                    type: 'include_in_standings',
                    message: 'Both teams will be grouped together in standings on your team page. If this team should not be included in your standings, answer NO and the dual match will only affect your overall record.',
                });
                break;
            case 'omit_from_standings':
                this.showPopUp({
                    type: 'omit_from_standings',
                    message: 'Teams will NOT be grouped together within the standings section on your team page and the dual match will only affect your overall record. If both teams should be grouped together in the standings, answer YES.',
                });
                break;
            default:
                break;
        }
    }

    async handleUpdateDualMatchEvent(values) {
        const dualMatch = await this.props.updateDualMatchEvent(values);
        return dualMatch;
    }

    showPopUp(popUpType, ev) {
        this.setState({
            showPopUp: true,
            popUpMessage: popUpType.message,
            popUpType: popUpType.type,
            topPoint: ev ? ev.nativeEvent.pageY : null,
        });
    }

    handlePopupCancel() {
        this.setState({
            showPopUp: false,
            popUpMessage: '',
            drawToDelete: null,
        });
    }

    handlePopUpConfirm() {
        const event = this.props.events.currentEvent.data;
        const drawId = this.state.drawToDelete;

        this.setState({
            showPopUp: false,
            popUpMessage: '',
            drawToDelete: null,
        }, async () => {
            switch (this.state.popUpType) {
                case 'delete_event': {
                    await this.props.deleteEvent(event.id, event.club.id);
                    this.redirectTo(`/clubs/${event.club.id}`);
                    break;
                }
                case 'delete_draw': {
                    this.props.deleteDraw(event.id, drawId);
                    break;
                }
                case 'include_in_standings': {
                    this.props.includeInAttStandings(event.id);
                    break;
                }
                case 'omit_from_standings': {
                    this.props.omitFromAttStandings(event.id);
                    break;
                }
                default:
                    break;
            }
        });
    }

    render() {
        const { playersDict, teamsDict, team1Players, team2Players } = this.state;
        const { adminSplash } = this.props.events;
        const event = this.props.events.currentEvent.data;
        const {
            teams,
            eventTeams,
            timesPublished,
            isSaving,
            eventSettings,
        } = event || {};
        const { isConference } = eventSettings || {};

        const adminOptions = [
            {
                id: 'include_in_standings',
                label: 'Include Match In Team Standings',
                value: 'include_in_standings',
                show: !isConference,
            },
            {
                id: 'omit_from_standings',
                label: 'Omit Match From Team Standings',
                value: 'omit_from_standings',
                show: isConference,
            },
            {
                id: 'delete',
                label: 'Delete',
                value: 'delete',
            },
        ];

        const adminDrawOptions = [
            {
                id: 'edit',
                label: 'Edit',
                value: 'edit',
            },
            {
                id: 'delete',
                label: 'Delete',
                value: 'delete',
            },
        ];

        console.log('dualMatchProfile render', event);

        return (
            <React.Fragment>
                {event && event.eventTeams && playersDict && teamsDict ? (
                    <div className={`${styles.dualMatchProfile}`}>
                        {head({
                            title: event?.name ? `UTR Sports | ${event?.name}` : config.defaultTitle,
                            description: event?.description,
                            url: `${config.appHost}/events/${event?.id}`,
                            keywords: 'UTR Sports Dual Match, Tennis players, Tennis results',
                            image: `https://www.${config.siteBaseUrl}/img/utr_sports/utr-sports-logo.svg`,
                            imageWidth: '930',
                            imageHeight: '395',
                        })}
                        {this.state.isAdmin &&
                            (
                                <AdminBar
                                    adminSplash={adminSplash}
                                >
                                    {!adminSplash &&
                                        (
                                            <div className="content">
                                                <div className="admin-info">
                                                    <div className="title">Status</div>
                                                    <div className="h6 text-medium">{event.published ? 'PUBLISHED' : 'DRAFT'}</div>
                                                </div>
                                                {/* <div className="admin-info">
                                                    <div className="title">Scores Posted</div>
                                                    <div className="h6 text-medium">10<span className="text-gray">&nbsp;/&nbsp;</span>10</div>
                                                </div> */}
                                                {!event.published && (
                                                    <React.Fragment>
                                                        {timesPublished
                                                            ? (
                                                                <div className="admin-info fs14 text-teal d-none d-md-inline-block">
                                                                    The event must be published again for scores to be visible <br />
                                                                    and count for ratings.
                                                                </div>
                                                            )
                                                            : (
                                                                <div className="admin-info fs14 text-teal d-none d-md-inline-block">
                                                                    Edit lineups and enter scores below. Click &quot;Publish&quot; once completed <br />
                                                                    and scores will be added to players&apos; records and rating.
                                                                </div>
                                                            )}
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        )}
                                    {!adminSplash && (
                                        <div className="buttons d-flex aic">
                                            {!event.published && (
                                                <button
                                                    type="button"
                                                    id="post"
                                                    className="btn btn-primary btn-lg text-uppercase button-float"
                                                    onClick={this.handlePublish}
                                                    data-testid="att-match.header.publish-btn"
                                                >
                                                    Publish
                                                </button>
                                            )}
                                            {event.published && (
                                                <button
                                                    type="button"
                                                    id="draft"
                                                    className="btn btn-default btn-lg button-float fs16"
                                                    onClick={this.handleUnpublish}
                                                    data-testid="att-match.header.edit-btn"
                                                >
                                                    Edit
                                                </button>
                                            )}
                                            {!event.published && (
                                                <PopOverMenu
                                                    horizontalEllipsis={false}
                                                    menuItems={adminOptions}
                                                    onSelected={this.handleAdminOptionSelect}
                                                    anchorClass="pop-over-menu-nchor"
                                                />
                                            )}
                                        </div>
                                    )}
                                    {!adminSplash && !event.published && (
                                        <div className="mobile-admin-info d-block d-md-none bt">
                                            {timesPublished
                                                ? (
                                                    <div className="admin-info fs12 text-teal">
                                                        The event must be published again for scores to be visible <br />
                                                        and count for ratings.
                                                    </div>
                                                )
                                                : (
                                                    <div className="admin-info fs12 text-teal">
                                                        Edit lineups and enter scores below. Click &quot;Publish&quot; once completed <br />
                                                        and scores will be added to players&apos; records and rating.
                                                    </div>
                                                )}
                                        </div>
                                    )}
                                    {adminSplash &&
                                        <h6>{adminSplash}</h6>}
                                </AdminBar>
                            )}
                        <Header
                            redirectTo={this.redirectTo}
                            event={event}
                            auth={this.props.auth}
                            isAdmin={this.state.isAdmin && !event.published}
                            handleScoreChange={this.handleTeamScoreChange}
                            handleWinnerChange={this.handleTeamWinnerChange}
                        />
                        <ResultsTab
                            event={event}
                            auth={this.props.auth}
                            isAdmin={this.state.isAdmin && !event.published}
                            playersDict={playersDict}
                            teamsDict={teamsDict}
                            teams={teams}
                            eventTeams={eventTeams}
                            team1Players={team1Players}
                            team2Players={team2Players}
                            handlePostScore={this.handlePostScore}
                            handlePlayerSelect={this.handlePlayerSelect}
                            handleTeamSelect={this.handleTeamSelect}
                            handleAddMatch={this.handleAddMatch}
                            handleDeleteMatch={this.handleDeleteMatch}
                            showAddDrawPopup={this.showAddDrawPopup}
                            adminDrawOptions={adminDrawOptions}
                            handleAdminDrawOptionSelect={this.handleAdminDrawOptionSelect}
                            isSaving={isSaving}
                        />
                        <div className={`mt32 mb32`}>
                            <div className={`container`} />
                        </div>
                        {this.state.showEditDualMatchEventPopup && (
                            <EditDualMatchEventPopup
                                onCloseClick={() => {
                                    this.setState({ showEditDualMatchEventPopup: false });
                                }}
                                club={event.club}
                                eventTeams={event.eventTeams}
                                defaultValues={{
                                    id: event.id,
                                    name: event.name,
                                    dualMatchClubs: _.map(event.eventTeams, (eventTeam) => ({
                                        clubId: eventTeam.clubId,
                                        isHome: eventTeam.isHome,
                                    })),
                                    eventStartUtc: `${event.eventSchedule.eventStartUtc}Z`,
                                    location: event.eventLocations[0].googleFormattedName,
                                    timezone: event.eventSchedule.timeZone.id,
                                }}
                                coreUI={this.props.coreUI}
                                onCtaClickAsync={this.handleUpdateDualMatchEvent}
                            />
                        )}
                        {this.state.showAddDrawPopup && (
                            <AddOrUpdateDualMatchEventDrawPopup
                                defaultValues={{
                                    formatTypeId: 1,
                                    name: null,
                                    genderId: getAddDrawGenderId(event),
                                }}
                                isEdit={false}
                                onCloseClick={this.hideAddDrawPopup}
                                onCtaClickAsync={this.handleAddDrawAsync}
                            />
                        )}
                        {this.state.showUpdateDrawPopup && (
                            <AddOrUpdateDualMatchEventDrawPopup
                                defaultValues={{
                                    drawId: this.state.drawIdToUpdate,
                                    name: this.state.drawNameToUpdate,
                                }}
                                isEdit={true}
                                onCloseClick={this.hideUpdateDrawPopup}
                                onCtaClickAsync={this.handleUpdateDrawAsync}
                            />
                        )}
                    </div>
                ) : null}
                {this.state.showPopUp
                    ? (
                        <Popup
                            closePopup={this.handlePopupCancel}
                            confirmPopup={this.handlePopUpConfirm}
                            message={this.state.popUpMessage}
                            topPoint={this.state.topPoint}
                            type={this.state.popUpType}
                        />
                    )
                    : null}
                {this.props.events.deleteEventFailed &&
                    (
                        <DeleteEventFailedPopup
                            dualMatchEvent={true}
                            close={() => this.props.closeDeleteFailedPopup()}
                        />
                    )}

            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showLoginPopUp: data => dispatch(loginPopUpActions.showLoginPopUp(data)),
        setRound: (round) => {
            dispatch(setRound(round));
        },
        getEvent: (eventId, reload) => dispatch(eventActions.getEvent(eventId, false, reload, false)),
        updateEventTeamScores: async (eventId, scoreObj) => {
            await dispatch(eventActions.updateEventTeamScores(eventId, scoreObj));
        },
        updateMatchPositions: (eventId, drawId, matchId, position, data) => {
            dispatch(eventActions.updateMatchPositions(eventId, drawId, matchId, position, data));
        },
        addMatchToRound: (drawId, roundId) => {
            dispatch(eventActions.addMatchToRound(drawId, roundId));
        },
        deleteMatch: (drawId, matchId) => {
            dispatch(eventActions.deleteMatch(drawId, matchId));
        },
        hideAdminSplash: () => {
            dispatch(eventActions.hideAdminSplash());
        },
        publishEvent: (eventId) => {
            dispatch(eventActions.publishEvent(eventId));
        },
        unPublishEvent: (eventId) => {
            dispatch(eventActions.unPublishEvent(eventId));
        },
        deleteEvent: async (eventId, clubId) => {
            await dispatch(eventActions.deleteEvent(eventId, clubId, true));
        },
        deleteDraw: (eventId, drawId) => {
            dispatch(eventActions.deleteDraw(eventId, drawId, true));
        },
        updateDualMatchEvent: async (values) => {
            await dispatch(eventActions.updateEvent(values, true));
        },
        closeDeleteFailedPopup: () => {
            dispatch(eventActions.closeDeleteFailedPopup());
        },
        showDeleteFailedPopup: () => {
            dispatch(eventActions.showDeleteFailedPopup());
        },
        addDraw: async (eventId, data) => {
            await dispatch(eventActions.addDraw(eventId, data));
        },
        updateDrawAsync: async (eventId, drawId, data) => {
            await dispatch(eventActions.updateDraw(eventId, drawId, data));
        },
        includeInAttStandings: (eventId) => {
            dispatch(eventActions.includeInAttStandings(eventId));
        },
        omitFromAttStandings: (eventId) => {
            dispatch(eventActions.omitFromAttStandings(eventId));
        },
    };
}

function mapStateToProps({ auth, coreUI, club, events }) {
    return { auth, coreUI, club, events };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdultTeamTennisMatchProfilePage);
